<script setup lang="ts">
type Props = {
  currentStatus: string;
  // Minha Conta V2 (ScreenRewards.vue) embute este componente antigo, mas
  // quer a cor de "ativo" igual ao resto do painel V2 (v2-primary), não o
  // laranja/azul do site antigo.
  variant?: 'default' | 'v2';
};

type RewardFilter = {
  id: RewardType | 'all';
  name: string;
};

const { currentStatus, variant = 'default' } = defineProps<Props>();

const { t } = useTexts();
const modelValue = defineModel<RewardFilter['id']>('modelValue', {
  required: true,
});

const rewardFilters = ref<RewardFilter[]>([
  {
    id: 'all',
    name: t('rewards.types.all'),
  },
  {
    id: 'money_real',
    name: t('rewards.types.money_real'),
  },
  {
    id: 'money_bonus',
    name: t('rewards.types.money_bonus'),
  },
  {
    id: 'money_cashback',
    name: t('rewards.types.money_cashback'),
  },
  {
    id: 'freespins',
    name: t('rewards.types.freespins'),
  },
  {
    id: 'freebets',
    name: t('rewards.types.freebets'),
  },
  // {
  //   id: 'ticket',
  //   name: t('rewards.types.ticket'),
  // },
]);

const { fetchRewardsFromApi } = useRewards();

async function handleFilterChange(filter: RewardFilter['id']) {
  modelValue.value = filter;
  await fetchRewardsFromApi(currentStatus, filter, 1);
}
</script>

<template>
  <div :class="$style.filtersContainer">
    <div :class="[$style.filter, $style.title]">
      {{ t('rewards.filters') }}
    </div>

    <button
      v-for="filter in rewardFilters"
      :key="filter.id"
      :class="[
        $style.filter,
        {
          [$style.activeFilter]:
            modelValue === filter.id && variant === 'default',
          [$style.activeFilterV2]: modelValue === filter.id && variant === 'v2',
        },
      ]"
      @click.prevent="handleFilterChange(filter.id)"
    >
      {{ filter.name }}
    </button>
  </div>
</template>

<style module lang="postcss">
.filtersContainer {
  @apply flex items-center gap-1 mt-4 flex-wrap;

  .filter {
    @apply text-texts/80 text-2xs font-semibold bg-texts/10 rounded-full py-0.5 px-2 border border-solid border-texts/5 whitespace-nowrap;

    &:hover {
      @apply bg-texts/15 text-texts/90 opacity-100;
    }

    &.activeFilter {
      @apply bg-primary/10 text-primary border-primary/10;
    }

    /* mesma cor de "ativo" usada no resto do Minha Conta V2 (ver
       components/user-v2/MenuItem.vue) */
    &.activeFilterV2 {
      @apply bg-v2-primary/20 text-white border-v2-primary;
    }

    &.title {
      @apply bg-texts/5 text-texts/30 cursor-default;
    }
  }
}
</style>
